import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

// export const API_SERVER = 'https://prontocasecash.com/api/v1';
export const API_SERVER = process.env.REACT_APP_API_URL;
import api from "../../constants/api.js";
const Login = ({ login }) => {
  const [formData, setFormData] = useState({ email: "", password: "", passwordVisible: false });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ email: "", password: "" });
  const notify = (msg) => toast(msg, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    type: 'error'
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    let valid = true;
    const newError = { email: "", password: "" };

    // Email validation
    if (!formData.email) {
      newError.email = "Email is required";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newError.email = "Please enter a valid email address";
      valid = false;
    }

    if (!formData.password) {
      newError.password = "Password is required";
      valid = false;
    } else if (formData.password.length < 6) {
      newError.password = "Password must be at least 6 characters long";
      valid = false;
    }

    setError(newError);
    return valid;
  };


  const handleLogin = async () => {
    if (!validateForm()) return;
    setLoading(true);
    const res = await api.auth.login({
      email: formData.email,
      password: formData.password,
      user_role: 'admin',
    });
    if(res.status == 'success'){
      login({ ...formData, token: res.result?.accessToken });
      setLoading(false);
    }else{
      notify(res.message);
      setLoading(false);
    }
  };
  

  return (
    <>
      <ToastContainer />
      <div className="login-container">
        <div className="login-box">
          <img src="./img/logo-new" alt=""/>
          <h2>Sign In</h2>

          <div className="text-field-wrapper">
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              className="input-field"
              value={formData.email}
              onChange={handleChange}
            />
            {error.email && <p className="error-text">{error.email}</p>}
          </div>
          <div className="text-field-wrapper">
            <div className="password-wrapper">
              <input
                type={formData.passwordVisible ? "text" : "password"}
                name="password"
                placeholder="Password"
                className="input-field"
                value={formData.password}
                onChange={handleChange}
              />
              <span
                className="eye-icon"
                onClick={() => setFormData({ ...formData, passwordVisible: !formData.passwordVisible })}
              >
                {formData.passwordVisible ? (
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6" height={12} width={12}>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6" height={12} width={12}>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                  </svg>
                )}
              </span>
            </div>
            {error.password && <p className="error-text">{error.password}</p>}
          </div>
          <button className="login-button" onClick={handleLogin} disabled={loading}>
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </div>
      </div>
    </>
  );
};

export default Login;
